import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject } from "rxjs";
import { Clipboard } from "app/models/clipboard";
import { MyFile } from "app/models/my-file";
import { FormTemplate } from 'app/models/template';

export function FilesClipboardServiceFactory() {
    return new ClipboardService('filesClipboard');
}

export function FormsClipboardServiceFactory() {
    return new ClipboardService('formsClipboard');
}

@Injectable()
export class ClipboardService implements OnDestroy {

    onClipboardChanged$: BehaviorSubject<Clipboard> = new BehaviorSubject<Clipboard>(this.getClipboard());

    constructor(private clipboardName: string = 'filesClipboard') { 
        window.addEventListener('storage', this.onStorageChanged.bind(this));
    }
    
    clearClipboard() {
        localStorage.removeItem(this.clipboardName);
        this.onClipboardChanged$.next(null);
    }

    setClipboard(operation_name: string, storageId: number, files: MyFile[] | FormTemplate[]) {
        let filesClipboard: Clipboard = {operation_name: operation_name, clipboardItems: []};

        files.forEach((file) => {
            filesClipboard.clipboardItems.push({storageId: storageId, path: file.path, type: file.type || file.form_type_id});
        });

        localStorage.setItem(this.clipboardName, JSON.stringify(filesClipboard));
        this.onClipboardChanged$.next(filesClipboard);
    }

    getClipboard() : Clipboard {
        let filesClipboard = localStorage.getItem(this.clipboardName);

        if (filesClipboard !== null) {
            return JSON.parse(filesClipboard) as Clipboard
        }

        return null;
    }

    private onStorageChanged(ev: StorageEvent) {
        if (ev.key === this.clipboardName) {
            if (ev.newValue != null)
                this.onClipboardChanged$.next(JSON.parse(ev.newValue) as Clipboard);
            else
                this.onClipboardChanged$.next(null);
        }
    }
 
    ngOnDestroy() {
        window.removeEventListener('storage', this.onStorageChanged.bind(this));
    }
}
